import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as ngrxEffects from '@ngrx/effects'
import * as ngrxRouterStore from '@ngrx/router-store'
import * as rxjs from 'rxjs'

import * as models from '../models'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * TODO: Add documentation
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Router extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /**
   * The key used to store the router state in the NgRx store
   *
   * @see {@link ngrxStore.createFeatureSelector}
   */
  public static readonly FEATURE_KEY = 'Router'

  /** @see {@link ngRouter.Router} */
  public readonly ngRouter = ngCore.inject(ngRouter.Router)
  /** @see {@link ngRouter.UrlSerializer} */
  public readonly urlSerializer = ngCore.inject(ngRouter.UrlSerializer)

  constructor() {
    super({
      // NOTE: this cannot have a `parent` since we want this to be treated like
      // a normal NgRx Feature with the appropriate feature key
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: Router.FEATURE_KEY,
      selectors: () => new Selectors(this),
    })

    this.registerEffects(effects.navigate())
  }

  /**
   * Used to listen to some of the underlying navigation events
   *
   * @see {@link https://ngrx.io/guide/router-store/actions}
   */
  public getRoutingAction$<K extends keyof typeof ROUTER_STORE_ACTION_TYPES>(
    status: keyof typeof ROUTER_STORE_ACTION_TYPES,
  ): rxjs.Observable<RouterAction<K>> {
    return this.injectables.actions.pipe(
      ngrxEffects.ofType(ROUTER_STORE_ACTION_TYPES[status]),
    )
  }
}

const ROUTER_STORE_ACTION_TYPES = {
  cancellation: ngrxRouterStore.ROUTER_CANCEL,
  error: ngrxRouterStore.ROUTER_ERROR,
  request: ngrxRouterStore.ROUTER_REQUEST,
  success: ngrxRouterStore.ROUTER_NAVIGATED,
} as const satisfies Record<store.actions.Op.Status, string>

type RouterAction<K extends keyof typeof ROUTER_STORE_ACTION_TYPES> = Extract<
  ngrxRouterStore.RouterAction<unknown, State.Payload>,
  {
    type: (typeof ROUTER_STORE_ACTION_TYPES)[K]
  }
>
